import { Link, Navigate } from 'react-router-dom';
import { handleApiErrors } from '../../../api/apiErrorHandler';
import { apiUrl } from '../../../api/apiUrl';
import http from '../../../api/axios';
import { useAuth } from '../../../context/AuthContext';
import { RegisterForm } from '../../../forms/Register/RegisterForm';
import { Values } from '../../../forms/Register/RegisterForm.types';
import logger from '../../../utils/logger';
import { useLoading } from '../../../context/loadingContext';

/**
 * A component for the registration page
 */
export const RegisterPage = () => {
  const { isAuthenticated, login } = useAuth();
  const { startLoading, stopLoading } = useLoading();
  /**
   * Handles registration form submit.
   * Sends registration API.
   * @param values form data
   */
  const handleSubmit = async (values: Values) => {
    logger.i(values);
    try {
      startLoading();
      const response = await http.apiPost({ url: apiUrl.REGISTER, data: values });
      if (response?.status === 200) {
        stopLoading();
        const { token } = response.data;
        login(token);
      }
    } catch (err) {
      stopLoading();
      handleApiErrors(err);
    }
  };

  if (isAuthenticated) return <Navigate to="/dashboard" />;

  return (
    <div className="mx-auto min-h-full h-screen flex items-center justify-center max-w-md py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl w-full space-y-8">
        <div className="mb-10">
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Sign Up</h2>
        </div>
        <RegisterForm onSubmit={handleSubmit} />
        <p className="mt-2 text-center text-sm text-gray-600 mt-5">
          Already have an account?{' '}
          <Link to="/signin" className="font-medium text-blue-600 hover:text-blue-500">
            Sign In.
          </Link>
        </p>
      </div>
    </div>
  );
};
